import { useCallback } from "react"

import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { firebase } from "../../../../services/firebase/firebase"
import { DeviceDocument } from "../../../../contexts/devices-context"
import { useLanguage } from "../../../../contexts/language-context"
import { AwsIotChangeGroupData } from "../../../../functions/aws/iot/aws-iot-changeGroup"

export default (device: DeviceDocument, onClose: () => void) => {
    const { L } = useLanguage()
    const { onStart, onSuccess, onError, processing } = useCloudFunction("aws-iot-changeGroup")

    const onRemove = useCallback(() => {
        onStart(L("Removing device from %s", device.group))
        httpsCallable<AwsIotChangeGroupData>(
            firebase.functions,
            "aws-iot-changeGroup",
        )({
            id: device.id,
            originGroup: device.group,
            targetGroup: device.organisation,
            organisation: device.organisation,
        })
            .then(onSuccess())
            .then(onClose)
            .catch(onError())
    }, [L, device])

    return { onRemove, processing }
}
